import styled from 'styled-components';

// Container geral da página (padding, fundo, etc).
export const Container = styled.div`
  padding: 20px;
  background: var(--surface);
  height: 90%;
  box-shadow: var(--shadow);
  border-radius: 8px;
  border: 1px solid var(--border);
  color: var(--text);
`;

// Título principal (h2)
export const Title = styled.h2`
  color: var(--text);
  margin-bottom: 20px;
`;

// Seções (cada bloco de informações)
export const Section = styled.div`
  margin-bottom: 30px;
  width: 100%;
  border-right: 1px solid var(--border);
`;

export const SectionUnion = styled.div`
  margin-bottom: 30px;
  width: 49%;
  border-right: 1px solid var(--border);
`;

export const UnionCardSections = styled.div`
  display: flex;
  justify-content: space-between;
`;

// Subtítulo de cada seção (h3)
export const SubTitle = styled.h3`
  color: var(--text);
  margin-bottom: 10px;
`;

// Tabela simples de pares Label/Value
export const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  color: var(--text);

  td {
    padding: 8px;
    vertical-align: top;
  }
`;

// Cada linha dessa tabela de pares
export const InfoRow = styled.tr`
  border-bottom: 1px solid var(--border);
`;

// Célula de “rótulo” (coluna da esquerda)
export const Label = styled.td`
  font-weight: 600;
  width: 30%;
  background: var(--surface-2);
`;

// Célula de “valor” (coluna da direita)
export const Value = styled.td`
  width: 70%;
`;

// Tabelas de serviços/peças que usam <table><th><td>
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: var(--text);

  th, td {
    border: 1px solid var(--border);
    padding: 8px;
    text-align: left;
  }
  th {
    background: var(--surface-2);
    color: var(--text-muted);
  }
`;
export const TableRow = styled.tr``;
export const TableCell = styled.td``;

// Caixa de resumo no final
export const SummaryBox = styled.div`
  background: var(--surface);
  color: var(--text);
  padding: 5px 20px;
  border-radius: 8px;
  position: fixed;
  bottom: 30px;
  width: 78%;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
`;


export const SectionButton = styled.div`
display: flex;
align-items: center;
margin-bottom: 20px;
`


// no seu arquivo de styled-components, adicione:

export const ScrollContainer = styled.div`
  max-height: 200px;       /* Ajuste conforme cabe 4 linhas */
  overflow-y: auto;
  color: var(--text);

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th {
    background: var(--surface-2);
    color: var(--text-muted);
    text-align: center;
  }

   td {
    border: 1px solid var(--border);
    padding: 8px;
    text-align: center;

  }

  /* Cabeçalho “grudado” no topo do ScrollContainer */
  thead th {
    position: sticky;
    top: 0;
    background: var(--surface-2);
    z-index: 2;
  }
`;

export const TitleContainer = styled.div`
display: flex;
width: 100%;
justify-content: space-between;
align-items: center;
color: var(--text);
`

export const ButtonPrintOrder = styled.button`
  height: 50px;
  width: 50px;
  border-radius: 8px;
  color: var(--text);
  font-size: 16px;
  font-weight: bold;
  border: none;
  background: none;

  &:hover {
    cursor: pointer;
    color: var(--accent);
  }
`;


export const ActionButton = styled.button`
    margin-left: 15px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--text-muted);

    &:hover {
      color: var(--accent);
    }

    &:first-child {
        margin-left: 0;
    }
`;


export const InputSection = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 10px;
    gap:15px;
    align-items: center;
`;
